module.export = {
  DEFAULT_OVERLAY_LAYER_MARGIN: 80,
  DEFAULT_OVERLAY_LAYER_SCALE: 0.15,
};
